import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import useTheme from '@mui/system/useTheme';
import Typography from '@mui/material/Typography';

import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

export default function NavInfo() {
  const { user } = useAuthContext();
  const theme = useTheme();
  return (
    <Stack
      sx={{
        px: 3.5,
        pt: 4,
        pb: 7,
        textAlign: 'right',
      }}
    >
      <Stack sx={{ width: 1 }} alignItems="end" justifyContent="flex-end">
        <Box>
          <Avatar
            src={user?.avatarURL}
            sx={{
              width: 56,
              height: 56,
              border: `solid 2px ${theme.palette.background.paper}`,
            }}
          />
        </Box>
        <Stack
          sx={{ mb: 0, mt: 1, width: 1 }}
          spacing={0.5}
          direction="row"
          justifyContent="flex-end"
          alignItems="baseline"
        >
          <Typography variant="subtitle2" letterSpacing="2px" noWrap>
            관리자
          </Typography>
          <Typography
            variant="h3"
            letterSpacing="2px"
            noWrap
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis', // Use ellipsis to indicate overflow
              maxWidth: '145px', // Adjust max width as needed
            }}
          >
            {user?.user_name}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
